// Fire `callback(el)` once per element the first time it becomes visible.
// Returns a disposer so callers can tear down on HTMX re-init.
export function onceVisible(elements, callback, { threshold = 0.25 } = {}) {
  if (!elements.length) return () => {};

  if (!("IntersectionObserver" in window)) {
    elements.forEach(callback);
    return () => {};
  }

  const obs = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          callback(entry.target);
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold },
  );

  elements.forEach((el) => obs.observe(el));
  return () => obs.disconnect();
}
